export default __webpack_public_path__ + "static/media/sdmobile-hero.421ae0ae.png";